import { Controller } from "@hotwired/stimulus"

// Lets the Surveillant General add custom monitoring zones inline on the sector
// form. New zone names are submitted as new_zones[] and created on save.
export default class extends Controller {
  static targets = ["container", "input"]
  static values = { placeholder: String }

  add() {
    const row = document.createElement("div")
    row.className = "flex items-center gap-2"
    row.dataset.surveillanceZonesTarget = "row"
    row.innerHTML = `
      <input type="text" name="new_zones[]" value=""
             placeholder="${this.placeholderValue}"
             class="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-cta focus:border-cta">
      <button type="button" data-action="click->surveillance-zones#remove"
              class="p-2 text-red-400 hover:text-red-600">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>`
    this.containerTarget.insertAdjacentHTML("beforeend", row.outerHTML)
  }

  remove(event) {
    event.target.closest("[data-surveillance-zones-target='row']")?.remove()
  }
}
